import { Route, Routes, useNavigate } from "react-router-dom";
import { Content } from "../layout/Content";
import { Header } from "../layout/Header";
import { Home } from "../pages/Home";
import { Enrichment } from "../pages/Enrichment";
import { SignAsUser } from "../pages/SignAsUser";
import { Blacklist } from "../pages/Blacklist";
import { Answers } from "../pages/Answers";
import { Forms } from "../pages/Forms";
import { Results } from "../pages/Results";
import { Import } from "../pages/Import";
import { Exports } from "../pages/Exports";
import { DetailsResults } from "../pages/DetailsResults";
import { CreateCampaign } from "../pages/CreateCampaign";
import { Campaign } from "../pages/Campaign";
import { BI } from "../pages/BI";
import { BiDetail } from "../pages/BI/Detail";
import { BiDashboard } from "../pages/BI/Dashboard";
import { WhatsApp } from "../pages/WhatsApp";
import { EmailTemplates } from "../pages/EmailTemplates";
import { DetailsPerson } from "../pages/DetailsPerson";
import { useCallback, useEffect } from "react";
import { useAuth } from "../hooks/useAuth";
import { useNotification } from "../hooks/useNotification";
import { Offers } from "../pages/Offers";
import { ResultsOffers } from "../pages/ResultsOffers";
import { DetailsOffers } from "../pages/DetailsOffers";
import { CampaignAwarded } from "../pages/CampaignAwarded";
import { CampaignAwardedId } from "../pages/CampaignAwardedId";
import { NewStore } from "../pages/DeliveryVip";
import { WithoutAccess } from '../pages/WithoutAcess'

export function RootRoutes() {
  const { token } = useAuth();
  const notification = useNotification();
  const navigate = useNavigate();

  const NotificationExport = useCallback(() => {
    notification.show(
      "Exportação concluída!",
      "Clique aqui para ver suas exportações",
      {
        sx: { cursor: "pointer" },
        onClick: () => {
          navigate("/exports");
          notification.close();
        },
      }
    );
  }, [notification, navigate]);

  useEffect(() => {
    const websocket = new WebSocket("wss://ws-crm.datasales.info/prd", [
      "http",
      token,
    ]);

    websocket.onmessage = (message) => {
      if (message.data === "export-completed") {
        NotificationExport();
      }
    };

    return () => {
      websocket.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Header>
      <Content>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="sign-as-user/:token" element={<SignAsUser />} />
          <Route path="enrichment" element={<Enrichment />} />
          <Route path="blacklist" element={<Blacklist />} />
          <Route path="answers" element={<Answers />} />
          <Route path="forms" element={<Forms />} />
          <Route path="form-delivery" element={<NewStore />} />
          <Route path="results" element={<Results />} />
          <Route path="results/:id" element={<DetailsResults />} />
          <Route path="create-campaign" element={<CreateCampaign />} />
          <Route path="campaign" element={<Campaign />} />
          <Route path="imports" element={<Import />} />
          <Route path="exports" element={<Exports />} />
          <Route path="bi" element={<BI />} />
          <Route path="bi/:biId" element={<BiDetail />} />
          <Route path="bi/:biId/:dashboardId" element={<BiDashboard />} />
          <Route path="whatsapp" element={<WhatsApp />} />
          <Route path="templates" element={<EmailTemplates />} />
          <Route path="people/:id" element={<DetailsPerson />} />
          <Route path="offers" element={<Offers />} />
          <Route path="results-offers" element={<ResultsOffers />} />
          <Route path="results-offers/:id" element={<DetailsOffers />} />
          <Route path="campaign-awarded" element={<CampaignAwarded />} />
          <Route path="campaign-awarded/:id" element={<CampaignAwardedId />} />
          <Route path="withou-access" element={<WithoutAccess />} />
        </Routes>
      </Content>
    </Header>
  );
}
